import React from 'react';
import { useLanguage } from '../context/LanguageContext';

export default function ShowcaseGallery() {
  const { t } = useLanguage();
  return (
    <div className="bg-white py-20 border-b border-slate-100">
      <div className="max-w-7xl mx-auto px-6">
        <h3 className="text-center text-base sm:text-lg md:text-xl font-black italic text-[#293e30] uppercase tracking-widest mb-10">
          {t('gallery.title')}
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-md transition-all duration-300 group border border-slate-100">
            <img 
              src="https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/636e989a-1208-40f5-bec5-d8ba5b8e927f.jpg" 
              alt="Klargøring og syn af bil" 
              className="w-full h-full object-cover transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/30 to-transparent" />
          </div>
          <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-md transition-all duration-300 md:translate-y-6 group border border-slate-100">
            <img 
              src="https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/7be2f407-6082-4e86-a26f-e06642f509cf.jpg" 
              alt="Professionel vurdering af bil" 
              className="w-full h-full object-cover transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/30 to-transparent" />
          </div>
          <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-md transition-all duration-300 group border border-slate-100">
            <img 
              src="https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/daf71058-73e3-4f8e-bca7-beb73c84487d.jpg" 
              alt="Gennemgang af bil og stand" 
              className="w-full h-full object-cover transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/30 to-transparent" />
          </div>
          <div className="relative aspect-[4/3] rounded-none overflow-hidden shadow-md transition-all duration-300 md:translate-y-6 group border border-slate-100">
            <img 
              src="https://assets.auxodev.dk/assets/5bfde40d-44ae-4b1e-9e89-bf8f3817c44f/03f7fa52-7b3a-4dac-bef4-5e16710c269c.jpg" 
              alt="Frikøbt og klar til ny ejer" 
              className="w-full h-full object-cover transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950/30 to-transparent" />
          </div>
        </div>
      </div>
    </div>
  );
}
